import React, { useState, useEffect, useRef } from 'react';
import styles from './LeadProfileCard.module.css';
import blueArrow from '../../images/icons/UserKycIcons/blueArrow.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { nameformat } from '../CommonMbTableCard/CommonMbTableCard';
import moment from 'moment';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import {
  faEnvelope,
  faPhoneAlt,
  faMars,
  faVenus,
  faTransgender,
  faCalendarWeek
} from '@fortawesome/pro-solid-svg-icons';
import PopUp from '../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import { requestCreditReport } from '../../common/constants/api';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { navigate } from 'gatsby';

export const DateFormat = date => {
  if (date && moment(date).isValid()) {
    return moment(date).format('DD-MM-YYYY');
  }
  return date;
};
function LeadProfileCard(props) {
  const [viewCreditUrl, setViewCreditUrl] = useState(
    '/app/leadprofile/creditReport'
  );
  const { sendeach, serialNo } = props;
  const { card, imgBox, more_action } = styles;
  const [show, setShow] = useState('');
  const [moreAction, setMoreAction] = useState(false);
  const moreActionRef = useRef('');
  const more = sendeach?.mainApplicant
    ? { color: 'white' }
    : { color: '#1BACB8' };

  useEffect(() => {
    document.body.addEventListener('click', onClickOutside);
    return () => document.body.removeEventListener('click', onClickOutside);
  }, []);

  useEffect(() => {
    if (props?.creditReportUrl) setViewCreditUrl(props.creditReportUrl);
  }, []);

  const onClickOutside = e => {
    const element = e.target;
    if (moreActionRef.current && !moreActionRef.current.contains(element)) {
      setMoreAction(false);
    }
  };

  return (
    <div className="relative ">
      <div
        className={`${
          sendeach?.mainApplicant == true ? 'text-green-900' : 'text-black-700'
        } pb-2`}
      >
        {sendeach?.mainApplicant == true ? (
          <div>First Applicant</div>
        ) : (
          <div>CO-Applicant {serialNo}</div>
        )}
      </div>

      <div
        className={` py-7  ${
          sendeach?.mainApplicant == true ? 'bg-green-900' : 'bg-white'
        } rounded-md ${
          sendeach?.mainApplicant == true ? 'text-white' : 'text-black-500'
        }  p-3 pb-2 text-sm 
    font-roboto font-normal ${card}`}
        style={{ minHeight: '182px' }}
      >
        <div className="w-auto " ref={moreActionRef}>
          {!props.hideMoreOption ? (
            <div
              className="w-10 ml-auto text-right"
              onClick={() => setMoreAction(!moreAction)}
            >
              <MoreHorizIcon
                style={Object.assign(more, { marginLeft: 'auto' })}
              />
            </div>
          ) : null}
          <div className={`${more_action}`}>
            {moreAction ? (
              <ShowMoreAction
                applicant_data={sendeach}
                setMoreAction={setMoreAction}
                viewCreditUrl={viewCreditUrl}
              />
            ) : null}
          </div>
        </div>
        {sendeach?.creditScore ? (
          <div className=" float-right">
            <p
              className={`text-right font-roboto font-medium text-base  ${
                sendeach?.mainApplicant ? 'text-white' : 'text-black-0'
              }`}
            >
              {sendeach?.creditScore}
            </p>
            <p
              className={`text-right font-roboto font-normal text-sm -my-1  ${
                sendeach?.mainApplicant ? 'text-white' : 'text-black-600'
              }`}
            >
              Credit Score
            </p>
          </div>
        ) : null}
        <div className="flex justify-between">
          <div className="flex text-base ">
            <span
              className={`bg-white flex justify-center content-center rounded-full  mr-2 ${imgBox}`}
            >
              <img
                src={sendeach?.imgUrl}
                alt=""
                className="w-full h-full p-1"
              />
            </span>
            <span
              className={
                sendeach?.mainApplicant == true
                  ? 'text-white'
                  : 'text-black-850'
              }
            >
              {nameformat(sendeach.name)}
            </span>
          </div>
          {/* <div className="relative">
            <div
              className="text-2xl font-medium relative h-0"
              onClick={() => {
                setShow(!show);
              }}
              style={{ top: '-22px' }}
            >
              ...
            </div>

            <CommonInfoCard show={show} setShow={setShow} />
          </div> */}
        </div>
        <div className="flex mt-2">
          <div className="pr-2">Customer ID- </div>
          <span>{sendeach?.id}</span>
        </div>
        <div className="flex justify-between  pt-2">
          <div className="flex items-center pb-2">
            <FontAwesomeIcon icon={faPhoneAlt} />
            <span
              style={{ letterSpacing: '1px' }}
              className="inline-block px-2"
            >
              {sendeach?.phoneNumber}
            </span>
          </div>
          <div className="flex items-center pb-2">
            <FontAwesomeIcon icon={faEnvelope} />
            <span className="inline-block px-2">{sendeach?.email}</span>
          </div>
        </div>
        <div className="flex justify-between pb-2">
          <div>
            <FontAwesomeIcon icon={faCalendarWeek} />
            <span className="inline-block px-2">
              {DateFormat(sendeach?.dob) || 'NA'}
            </span>
          </div>
          <div className="pr-16">
            {sendeach?.gender == 'Male' ? (
              <FontAwesomeIcon icon={faMars} />
            ) : sendeach?.gender == 'Female' ? (
              <FontAwesomeIcon icon={faVenus} />
            ) : (
              <FontAwesomeIcon icon={faTransgender} />
            )}
            <span className="inline-block px-2">
              {sendeach?.gender ? sendeach.gender : 'NA'}
            </span>
          </div>
        </div>
        <div
          className={`${
            sendeach?.mainApplicant == true ? 'text-white' : 'text-green-900'
          }`}
        >
          Profession :
          <span className="font-medium ml-1">
            {sendeach?.profession || 'NA'}
          </span>
        </div>
      </div>
    </div>
  );
}

const ShowMoreAction = ({ applicant_data, setMoreAction, viewCreditUrl }) => {
  const [popupText, setPopUpText] = useState('Loading...');
  const [popupType, setPopUpType] = useState('loading');
  const [popUpShow, setPopUpShow] = useState(false);
  const [dontClose, setDontClose] = useState(true);
  const [autoClose, setAutoClose] = useState(true);
  const { more_action_sub_container } = styles;

  const sendRequestForCreditReport = () => {
    setPopUpType('loading');
    setPopUpText('Sending Request Please Wait...!');
    setPopUpShow(true);
    setDontClose(true);
    setAutoClose(false);
    requestCreditReport(getApplicantionInfo().leadId, applicant_data.id)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setPopUpType('success');
        setPopUpText('Credit Report Request has been sent to Customer');
        setAutoClose(true);
      })
      .catch(error => {
        setPopUpShow(false);
      });
  };

  return (
    <div
      className={`${more_action_sub_container} w-full absolute  rounded px-4 py-3 bg-white ${
        applicant_data?.mainApplicant ? '' : 'shadow '
      }`}
    >
      {!applicant_data.creditScore ? (
        <p
          className={`font-roboto font-normal text-sm  text-green-900`}
          onClick={sendRequestForCreditReport}
        >
          Request credit Report
        </p>
      ) : (
        <p
          className={`font-roboto font-normal text-sm text-green-900 text-green-900`}
          onClick={() => navigate(viewCreditUrl)}
        >
          View credit Report
        </p>
      )}
      <PopUp
        type={popupType}
        text={popupText}
        setShow={setPopUpShow}
        show={popUpShow}
        dontClose={dontClose}
        autoClose={autoClose}
      />
    </div>
  );
};
export default withErrorHandler(LeadProfileCard);
